<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <SearchTitle label='住培生分数汇总统计' Url='/report/score/stu/list'></SearchTitle>
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <!--begin: Search Form -->
        <div class="m-form m-form--label-align-right">
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">管理单元：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.secretarysec" filterable placeholder="全部" @change="ManageSecChange">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in managesecOptions" :key="item.DictItemID" :label="item.DictItemName" :value="item.DictItemID">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">科室：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.stusec" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in secOptions" :key="item.DictItemID" :label="item.DictItemName" :value="item.DictItemID">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <SearchNormalText v-model='condition.stuname' label='姓名'></SearchNormalText>
          <SearchNormalText v-model='condition.stuno' label='工号'></SearchNormalText>
          <ZPGLSearchDictItemSelect v-model='condition.stuspec' label='专业' :dictid='this.$utils.DictEnum.specialty'></ZPGLSearchDictItemSelect>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">培养年限：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.stueduyear" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in trainingyearOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">开始时间：</label>
              </div>
              <div class="m-form__control">
                <el-date-picker v-model="condition.beginyear" type="month" placeholder="开始时间" value-format="yyyy-MM">
                </el-date-picker>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">结束时间：</label>
              </div>
              <div class="m-form__control">
                <el-date-picker v-model="condition.endyear" type="month" placeholder="结束时间" value-format="yyyy-MM">
                </el-date-picker>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;">
          <SearchButton :url='searchUrl' ref="btnSearch"></SearchButton>
          <ExportButton :url='exportUrl' buttonname="导出"></ExportButton>
        </div>
        <!--end: Search Form -->
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <!--begin: Datatable -->
          <el-table v-loading="loading" :data="tableData" stripe style="width: 100%" size="medium" @row-click="UserMonthly">
            <el-table-column prop="StuName" label="姓名">
            </el-table-column>
            <el-table-column prop="StuNo" label="工号">
            </el-table-column>
            <el-table-column prop="ManageSecName" label="管理单元">
            </el-table-column>
            <el-table-column prop="SectionName" label="科室">
            </el-table-column>
            <el-table-column prop="SpecialityName" label="专业">
            </el-table-column>
            <el-table-column prop="StuYearName" label="届别">
            </el-table-column>
            <el-table-column prop="StuEduYearName" label="培养年限">
            </el-table-column>
            <el-table-column prop="ScoreCount" label="总分">
            </el-table-column>
            <el-table-column prop="CPICount" label="评分次数">
            </el-table-column>
            <el-table-column label="平均分">
              <template slot-scope="scope">
                {{scope.row.AvgScore|formatNum}}
              </template>
            </el-table-column>
          </el-table>
          <!--end: Datatable -->
          <div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="condition.currentPage"
              :page-sizes="[2, 10, 20, 30, 40]" :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="condition.recordCount">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ScoreStuList',
    data() {
      return {
        condition: {
          token: '',
          username: '',
          rolelevel: '',
          stuname: '',
          stusec: '',
          stuno: '',
          stuspec: '',
          stueduyear: '',
          beginyear: '',
          endyear: '',
          pageSize: 10,
          currentPage: 1,
          recordCount: 0,
          firstSearch: true,
          secretarysec: ''
        },
        trainingyearOptions: [{
          value: '1',
          label: '一年生'
        }, {
          value: '2',
          label: '两年生'
        }, {
          value: '3',
          label: '三年生'
        }, {
          value: '4',
          label: '往届生'
        }],
        tableData: null,
        searchUrl: this.$utils.Url.zpgl + '/api/APICPI/ReportScoreStuList',
        exportUrl: this.$utils.Url.zpgl + '/api/APICPI/ReportScoreStuListOut',
        loading: true,
        secOptions: [],
        managesecOptions: []
      }
    },
    filters: {
      formatNum(val) {
        return val.toFixed(2)
      }
    },
    methods: {
      // 调整每页显示数
      handleCurrentChange: function(val) {
        this.condition.firstSearch = false
        this.condition.currentPage = val
        this.$refs.btnSearch.Search()
      },
      // 分页操作
      handleSizeChange: function(val) {
        this.condition.firstSearch = false
        this.condition.pageSize = val
        this.condition.currentPage = 1
        this.$refs.btnSearch.Search()
      },
      UserMonthly: function(row) {
        this.$router.push({
          name: 'ScoreStuUser',
          params: {
            id: row.StuID,
            name: row.StuName
          }
        })
      },
      LoadManageSec: function() {
        var args = {
          token: this.condition.token,
          username: this.condition.username,
          rolelevel: this.condition.rolelevel
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/ManageSecionList', args, function(data) {
          that.managesecOptions = data.Data
        }, null, null, null)
      },
      ManageSecChange: function() {
        this.condition.sec = ''
        this.secOptions = []
        this.LoadCPSec()
      },
      LoadCPSec: function() {
        var args = {
          token: this.condition.token,
          username: this.condition.username,
          rolelevel: this.condition.rolelevel,
          mamagesec: this.condition.secretarysec
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/CPSecList', args, function(data) {
          that.secOptions = data.Data
        }, null, null, null)
      }
    },
    mounted: function() {
      this.condition.token = sessionStorage.getItem('token')
      this.condition.username = sessionStorage.getItem('username')
      this.condition.rolelevel = sessionStorage.getItem('rolelevel')
      var date = new Date()
      var year = date.getFullYear()
      this.condition.beginyear = String(year) + "-1"
      this.condition.endyear = String(year) + "-12"
      this.LoadManageSec()
      this.LoadCPSec()
      this.$refs.btnSearch.Search()
    }
  }
</script>

<style scoped="scoped">
  /deep/.el-input {
    width: 220px;
  }
</style>
